/**
 * How many tickers are users allowed to add to ticker comparison tool
 */
export const _tickerComparisonLimit = 4;
/**
 * How many portfolios are users allowed to add to portfolio comparison tool
 */
export const _portfolioComparisonLimit = 4;
